import React from "react";
import whyMarketPulse from "assets/why_market_pulse.svg";
import CONSTANTS from "constants/constants";

const { MARKET_PULSE } = CONSTANTS;

const WhyMarketPulse = () => (
  <section className="why-marketpulse pb1 pt2">
    <div className="why-marketpulse-title dvt-section-header">
      <span className="why-marketpulse-title-highlight">{MARKET_PULSE.WHY_TITLE_HIGHLIGHT}</span>{MARKET_PULSE.WHY_TITLE}
    </div>
    <div className="why-marketpulse-desc fw-500">
      {MARKET_PULSE.WHY_DESC}
    </div>
    <div className="why-marketpulse-graphic mb1">
      <img src={whyMarketPulse} alt="Why Market Pulse" className="marketpulse-img" />
    </div>
  </section>
);

export default WhyMarketPulse; 